import { PropsWithChildren } from 'react';

import { Media, MediaProps } from '../02-atoms/Media';
import { hasMedia } from '../02-atoms/Media.utils';
import { Gallery } from './Gallery';

export interface LeriProps extends PropsWithChildren {
  /** The media */
  media?: MediaProps;
  /** Optional media slides, rendered as a slider when more than one */
  slides?: MediaProps[];
  /** Even or odd item */
  even?: boolean;
  /** Optional label for previous slide */
  prevLabel?: string;
  /** Optional label for next slide */
  nextLabel?: string;
  /** Optional label for swipe indicator */
  swipeLabel?: string;
}

/** A left/right component rendering content and media */
export const Leri = ({
  media,
  slides,
  even,
  prevLabel,
  nextLabel,
  swipeLabel,
  children,
}: LeriProps) => {
  const mediaSlides = (slides ?? []).filter((slide) => hasMedia(slide));
  const singleMedia = mediaSlides[0] ?? media;

  return (
    <div className={'leri leri--' + (even ? 'even' : 'odd')}>
      <div className="leri__wrapper">
        {mediaSlides.length > 1 ? (
          <Gallery
            className="leri__slider"
            slider
            items={mediaSlides}
            prevLabel={prevLabel}
            nextLabel={nextLabel}
            swipeLabel={swipeLabel}
          />
        ) : (
          hasMedia(singleMedia) && (
            <Media className="leri__media" {...singleMedia} />
          )
        )}
        <div className="leri__content">{children}</div>
      </div>
    </div>
  );
};
